export default "/images/vendor/flag-icons/flags/4x3/bn.svg?0c303e73dc3f11bddc6a7f4f576e76d9";